import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";

import { cloneLiveElement, invalidateLiveElement } from "actions/live_elements";

import _ from 'lodash';
import cx from 'classnames';
import { getBaseUrl } from "services/util";

import styles from './liveElement.module.scss';


export const CloneLiveElementPage = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  let { id } = useParams();

  const cloning = useSelector(state => _.get(state, 'liveElements.liveElement.clone.cloning'));
  const clonedLiveElement = useSelector(state => _.get(state, 'liveElements.liveElement.clone.item'));

  useEffect(() => {
    dispatch(cloneLiveElement(id));
  }, []);

  useEffect(() => {
    if(!cloning && clonedLiveElement){
      const clonedId = _.get(clonedLiveElement, 'id');
      var url = `${baseUrl}/liveElement/${clonedId}`;
      history.replace(url);

      dispatch(invalidateLiveElement());
    }
  }, [cloning, clonedLiveElement]);
  
  return (
    <div className={cx(styles.cloneStoryboard, styles.loading)}>
      Cloning live element....
    </div>
  );
}